/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_OverlineInputs */

const en_mk_mx_overline = /** @type {(inputs: Mk_Mx_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan comparison`)
};

const id_mk_mx_overline = /** @type {(inputs: Mk_Mx_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbandingan paket`)
};

/**
* | output |
* | --- |
* | "Plan comparison" |
*
* @param {Mk_Mx_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_overline = /** @type {((inputs?: Mk_Mx_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_overline(inputs)
	return en_mk_mx_overline(inputs)
});